import { Pencil, Trash2, ArrowRight } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { toast } from 'react-toastify';
import { useStore } from '../../../../hooks/useStore';
import type { IHospitalResult } from '../../../../models/hospital/HospitalModel';
import styles from '../HospitalManagement.module.css';

export type HospitalManagementActionCellProps = {
  row: IHospitalResult;
};

const HospitalManagementActionCell = ({ row }: HospitalManagementActionCellProps) => {
  const { popupStore, hospitalStore, authStore } = useStore();
  const isAdmin = authStore.isAdmin;

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    hospitalStore.setSelectedHospitalToEdit(row);
    popupStore.setIsEditHospitalOpen(true);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isAdmin) {
      toast.error('Bu işlem için admin yetkisi gereklidir.');
      return;
    }
    hospitalStore.setSelectedHospitalToDelete(row);
    popupStore.setIsDeleteConfirmationOpen(true);
  };

  const handleSelectTags = (e: React.MouseEvent) => {
    e.stopPropagation();
    hospitalStore.setSelectedHospitalForTags(row);
    popupStore.setIsSelectTagsOpen(true);
  };

  return (
    <div className={styles.actionCell}>
      <button onClick={handleEdit} className={styles.editButton} title="Düzenle">
        <Pencil size={16} strokeWidth={2} />
      </button>
      <button
        onClick={handleDelete}
        className={`${styles.deleteButton} ${!isAdmin ? styles.disabledButton : ''}`}
        title={isAdmin ? 'Sil' : 'Bu işlem için admin yetkisi gereklidir'}
        disabled={!isAdmin}
      >
        <Trash2 size={16} strokeWidth={2} />
      </button>
      <button onClick={handleSelectTags} className={styles.selectButton} title="Etiket Seç">
        <ArrowRight size={16} strokeWidth={2} />
      </button>
    </div>
  );
};

export default observer(HospitalManagementActionCell);
